type BetaBadgeProps = {
  className?: string;
  variant?: 'light' | 'dark';
};

export const BetaBadge = ({ className = '', variant = 'light' }: BetaBadgeProps) => {
  const variantStyles = variant === 'dark'
    ? 'text-white/70 bg-white/10'
    : 'text-gray-500 bg-gray-100';

  return (
    <span
      className={`text-[9px] font-medium px-1.5 py-0.5 rounded ml-1 ${variantStyles} ${className}`}
      aria-label="beta feature indicator"
    >
      beta
    </span>
  );
};
